import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Redirect, Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Keywords from "./pages/Keywords";
import Settings from "./pages/Settings";
import TeamManagement from "./pages/TeamManagement";
import Unauthorized from "./pages/Unauthorized";
import MarketRadar from "./pages/MarketRadar";
import AiPerformance from "./pages/AiPerformance";
import AiPerformanceKeywords from "./pages/AiPerformanceKeywords";
import AiPerformancePages from "./pages/AiPerformancePages";
import AiEvidence from "./pages/AiEvidence";
import AEOAudit from "./pages/AEOAudit";
import ContentOptimizer from "./pages/ContentOptimizer";

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/dashboard"} component={Dashboard} />
      <Route path={"/keywords"} component={Keywords} />
      <Route path={"/trends"} component={MarketRadar} />
      <Route path={"/reports"} component={() => <Redirect to="/dashboard" />} />
      <Route path={"/reports/new"} component={() => <Redirect to="/dashboard" />} />
      <Route path={"/reports/:id"} component={() => <Redirect to="/dashboard" />} />
      <Route path={"/team"} component={TeamManagement} />
      <Route path={"/unauthorized"} component={Unauthorized} />
      <Route path={"/roadmap"} component={() => <Redirect to="/dashboard" />} />
      <Route path={"/aeo-audit"} component={AEOAudit} />
      <Route path={"/content-optimizer"} component={ContentOptimizer} />
      <Route path={"/monetization"} component={() => <Redirect to="/dashboard" />} />
      <Route path={"/content-tasks"} component={() => <Redirect to="/dashboard" />} />
      <Route path={"/templates"} component={() => <Redirect to="/dashboard" />} />
      <Route path={"/article-projects/create"} component={() => <Redirect to="/dashboard" />} />
      <Route path={"/article-projects/:id"} component={() => <Redirect to="/dashboard" />} />
      <Route path="/ai-performance" component={AiPerformance} />
      <Route path="/ai-performance/keywords" component={AiPerformanceKeywords} />
      <Route path="/ai-performance/pages" component={AiPerformancePages} />
      <Route path="/ai-performance/evidence" component={AiEvidence} />
      <Route path="/keyword-groups" component={() => <Redirect to="/dashboard" />} />
      <Route path={"/settings"} component={Settings} />
      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
      >
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
